import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

export interface LeaderTimesheetCounts {
  leaderName: string;
  pendingSubmission: number;
  pendingApproval: number;
  approved: number;
  rejected: number;
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class OpsTimesheetTrendsService {
  constructor(private http: HttpClient) {}

  getStatusCountsByLeader(month?: number, year?: number): Observable<LeaderTimesheetCounts[]> {
    let params = new HttpParams();
    if (month != null) params = params.set('month', String(month));
    if (year != null) params = params.set('year', String(year));
    return this.http.get<LeaderTimesheetCounts[]>(
      `${environment.apiUrl}/metrics/timesheets/status-counts-by-leader`,
      { params }
    );
  }
}
